export const VISIBLE_NARRATIVES = 4;
